module.exports = __webpack_public_path__ + "e9cf3bece3a4b0a6a8c780dad28e14f5.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/covers/cover_13.jpg
 ** module id = 595
 ** module chunks = 0
 **/